module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point02_02_winter-e665402bfa2a53cd3f206ee2d7a3f557.jpg";